
import user from './user';
import api from './api';
import jobs from './jobs';

export default {
    user: user,
    api: api,
    jobs: jobs
};